import React, { useState, useEffect } from 'react';
import { getCompanias } from '../../redux/compania/actions';
import { Alert, Modal, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getEquipment, saveEquipment, editEquipment, deleteEquipment } from '../../redux/equipmentAsig/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import messages from '../../redux/messages';
import CustomTable from '../../components/CustomTable';

const EquipmentAsign = props => {

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);

  const columns = [
    {
      Header: 'Codigo',
      accessor: 'codigo'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    {
      Header: 'Service tag',
      accessor: 'service_tag'
    },
    // {
    //   Header: 'Estado',
    //   accessor: 'estado',
    //   Filter: ''
    // },
    {
      Header: 'Sociedad',
      accessor: 'sociedad',
      // Filter: '',
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  //Redux
  const dispatch = useDispatch();
  
  const loading = useSelector(store => store.equipment.loading);
  const data = useSelector(store => store.equipment.equipment);
  const dataLenght = useSelector(store => store.equipment.equipmentLength);
  const saveEquipmentLoader = useSelector(store => store.equipment.saveLoader);
  //Sociedad
  const compania = useSelector(store => store.compania.compania);
  const companiaLoader = useSelector(store => store.compania.loading);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  useEffect(() => {
    dispatch(getEquipment({
      filter: props.match.params.id,
      empleado: props.match.params.id}, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type]);

  useEffect(() => {
    dispatch(getCompanias(parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.type])

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const oData = {
      codigo: e.target.codigo.value,
			descripcion: e.target.descripcion.value,
			service_tag: e.target.service_tag.value,
			// estado: e.target.estado.value,
			sociedad: e.target.sociedad.value,
			empleado: parseInt(props.match.params.id)
    }

    if(edit){
      dispatch(editEquipment(oData, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }else{
      dispatch(saveEquipment(oData, parseInt(props.match.params.type)));
      setShowModal(false);
    }

  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEquipment(id, index, parseInt(props.match.params.type)));
    }
  }

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <Button
                variant="primary"
                size="sm"
                onClick={() => onAdd()}>Agregar nuevo</Button>
            </h2>
            <hr />
            <h6>Asignación de equipo</h6>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center" />
              </div>
            ) : dataLenght > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
              </>
            )
          }
          {
            dataLenght === 0 && (
              <Alert variant="info" className="my-4">
                No tiene equipo asignado
              </Alert>
            )
          }
        </div>
      </div>
      <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar asignación de equipo' : 'Crear asignación de equipo'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <Row>
            <Form.Group as={Col} sm="12" md="12" lg="4" controlId="codigo">
                <Form.Label className="ml-2">Código</Form.Label>
                <Form.Control
                  name="codigo"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-z0-9]+"
                  defaultValue={edit ? editItem.codigo : null}
                  placeholder="Código"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="descripcion">
                <Form.Label className="ml-2">Descripción</Form.Label>
                <Form.Control
                  name="descripcion"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  defaultValue={edit ? editItem.descripcion : null}
                  placeholder="Descripción de equipo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="service_tag">
                <Form.Label className="ml-2">Service tag</Form.Label>
                <Form.Control
                  name="service_tag"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-z0-9]+"
                  defaultValue={edit ? editItem.service_tag : null}
                  placeholder="service_tag"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite caracteres alfanuméricos
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              {/* <Form.Group as={Col} sm="12" md="12" lg="4" controlId="estado">
                <Form.Label className="ml-2">Estado</Form.Label>
                <Form.Control
                  name="estado"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.estado : null}
                  placeholder="Estado"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un correo valido
                </Form.Control.Feedback>
              </Form.Group> */}
              {/* <Form.Group as={Col} controlId="sociedad">
                <Form.Label className="ml-2">Sociedad</Form.Label>
                <Form.Control
                  name="sociedad"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  defaultValue={edit ? editItem.sociedad : null}
                  placeholder="Sociedad"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group as={Col} controlId="sociedad">
                <Row className="align-items-end">
                  <Col sm={ companiaLoader ? '10': '12' }>
                    <Form.Label className="ml-2">Sociedad</Form.Label>
                    <Form.Control
                      as="select"
                      name="sociedad"
                      className="rounded-pill"
                      required
                      defaultValue={ edit ? editItem.sociedad : null }
                      placeholder="Sociedad">
                        {
                          compania.map(item => (
                            <option key={item.id} value={item.id}>{item.nombre}</option>
                          ))
                        }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {
                    companiaLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )
                  }
                </Row>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveEquipmentLoader}  
              variant="primary" 
              type="submit">
                {
                  saveEquipmentLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default EquipmentAsign
